import styled from '@emotion/styled'
import { IconRefresh } from '../../../icons/IconRefresh/IconRefresh'
import { IconUpArrow } from '../../../icons/IconUpArrow/IconUpArrow'
import { calcRem, easing, themedValue } from '../../../__styling'

interface StyledButtonProps {
    show: boolean
}

export const StyledButton = styled('button')<StyledButtonProps>(
    ({ theme, show }) => ({
        backgroundColor: theme.colors.actions.button.primary.background.default,
        borderRadius: calcRem(32),
        marginTop: theme.margins.md,
        marginBottom: theme.margins.sm,
        height: calcRem(40),
        cursor: 'pointer',
        border: `1px solid ${theme.colors.brand}`,
        position: 'sticky',
        top: 20,
        margin: '0 auto',
        zIndex: 1000,
        display: 'flex',
        color: theme.colors.actions.button.primary.text.default,
        opacity: show ? 1 : 0,
        pointerEvents: show ? 'initial' : 'none',
        transition: `opacity ${easing.easeOut.med}, box-shadow ${easing.easeOut.fast}, transform ${easing.easeOut.fast}`,

        boxShadow: '0px 4px 11px 4px rgb(0 0 0 / 18%)',

        '&:focus': {
            backgroundColor: themedValue(theme, {
                thewest: '#114ce4', // TODO: Where do these colours come from
                perthnow: '#114ce4',
                sevennews:
                    theme.colors.actions.button.primary.background.default,
                fallback: undefined,
            }),
            borderColor: themedValue(theme, {
                thewest: '#114ce4',
                perthnow: '#114ce4',
                sevennews:
                    theme.colors.actions.button.primary.background.default,
                fallback: undefined,
            }),
            outline: 'none',

            boxShadow: '0px 2px 10px 10px rgba(9, 180, 192, 0.18)',
        },

        '&:hover': {
            backgroundColor: themedValue(theme, {
                thewest: '#114ce4',
                perthnow: '#114ce4',
                sevennews:
                    theme.colors.actions.button.primary.background.default,
                fallback: undefined,
            }),
            borderColor: themedValue(theme, {
                thewest: '#114ce4',
                perthnow: '#114ce4',
                sevennews:
                    theme.colors.actions.button.primary.background.default,
                fallback: undefined,
            }),
            boxShadow: '0px 9px 21px 3px rgb(0 0 0 / 30%)',
            transform: `translateY(-4px)`,
        },

        '&:active': {
            backgroundColor: themedValue(theme, {
                thewest: '#0231b5',
                perthnow: '#0231b5',
                sevennews:
                    theme.colors.actions.button.primary.background.default,
                fallback: undefined,
            }),
            borderColor: themedValue(theme, {
                thewest: '#0231b5',
                perthnow: '#0231b5',
                sevennews:
                    theme.colors.actions.button.primary.background.default,
                fallback: undefined,
            }),
            outline: 'none',
        },
    }),
)

export const StyledButtonInnerContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    padding: calcRem(10, 10),
    gap: calcRem(6),

    '& > span': {
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: theme.fonts.sansSerif,
        fontWeight: 700,
        fontSize: calcRem(15),
        lineHeight: calcRem(16),
    },
}))

export const StyledArrow = styled(IconUpArrow)(({ theme }) => ({
    width: calcRem(12),
    height: calcRem(14),
    fill: theme.colors.actions.button.primary.text.default,
}))

export const StyledSpinner = styled(IconRefresh)(({ theme }) => ({
    width: calcRem(12),
    height: calcRem(14),
    fill: theme.colors.actions.button.primary.text.default,
}))
